<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01">[A wasp] was sucking jam on my plate and I cut him in half. He paid no attention, merely went on with his meal, while a tiny stream of jam trickled out of his severed esophagus. Only when he tried to fly away did he grasp the dreadful thing that had happened to him.</p>
<p class="fm-02">G<span class="smallcaps">EORGE</span> O<span class="smallcaps">RWELL</span>, <i>Collected Essays</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?90e7c4d0